// extracted by extract-css-chunks-webpack-plugin
module.exports = {"narrow":"narrow-2GAEL"};